import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './modal.module.scss'

export const SIZE_TYPES = ['small', 'medium']

const ModalFilters = ({
  visible,
  size,
  HeaderContent,
  bgBackground,
  children,
  onClickOverlay,
  modalClassName,
  height,
  padding
}) => {
  const rootStyles = classNames(styles.root, {
    [styles.visible]: visible
  })

  const modalStyles = classNames(styles.modal, modalClassName, {
    [styles[size]]: size,
    [styles.bgBackground]: bgBackground
  })

  const containerStyles = {}

  if (height) containerStyles.height = height
  if (padding) containerStyles.padding = padding

  useEffect(() => {
    const body = document.querySelector('body')
    if (visible) {
      body.style.overflow = 'hidden'
    } else {
      body.style.overflow = ''
    }
  }, [visible])

  return (
    <div className={rootStyles}>
      <div className={styles.overlay} onClick={onClickOverlay} />
      <div style={containerStyles} className={modalStyles}>
        {HeaderContent && (
          <div className={styles.headerModal}>
            <HeaderContent />
          </div>
        )}
        <div className={styles.modalContent}>{children}</div>
      </div>
    </div>
  )
}

ModalFilters.defaultProps = {
  visible: true,
  HeaderContent: null,
  children: null,
  size: 'small',
  bgBackground: false,
  height: null,
  padding: null,
  onClickOverlay: null,
  modalClassName: null
}

ModalFilters.propTypes = {
  visible: PropTypes.bool,
  size: PropTypes.oneOf(SIZE_TYPES),
  HeaderContent: PropTypes.func,
  bgBackground: PropTypes.bool,
  onClickOverlay: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.element
  ]),
  height: PropTypes.string,
  padding: PropTypes.string,
  modalClassName: PropTypes.string
}

export default ModalFilters
